import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { NavController, NavParams, Slides, ViewController } from 'ionic-angular';
import { MyPicsListModel } from '../../providers/user/user';


/**
 * Generated class for the PictureViewerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
export interface PicturePagerEvent {
  list: MyPicsListModel[]
  index: number,
}

@Component({
  selector: 'page-picture-viewer',
  templateUrl: 'picture-viewer.html',
})
export class PictureViewerPage {


  @Output()
  buttonAction: EventEmitter<any>;
  @Output()
  button1Action: EventEmitter<any>;
  pictures: MyPicsListModel[] = [];
  activeIndex: number;

  @ViewChild("sliderBig")
  sliderBig: Slides;

  @ViewChild("sliderMini")
  sliderMini: Slides;
  icon: string;
  icon1: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController
  ) {
    console.log(navParams.data.emitter1);
    this.buttonAction = navParams.data.emitter;
    this.button1Action = navParams.data.emitter1;
    this.pictures = navParams.data.pictures;
    this.activeIndex = navParams.data.activeIndex;
    this.icon = navParams.data.icon;
    this.icon1 = navParams.data.icon1;
  }


  ngAfterViewInit() {
    if (this.sliderMini) {
      this.sliderMini.freeMode = true;
    }
  }

  async buttonClick() {
    if (this.buttonAction) {
      this.buttonAction.emit({ list: this.pictures, index: this.sliderBig.getActiveIndex() });
    }
  }
  async button1Click() {
    if (this.button1Action) {
      this.button1Action.emit({ list: this.pictures, index: this.sliderBig.getActiveIndex() });
    }
    this.dismiss();
  }

  changeBig() {
    if (this.sliderMini && this.sliderBig) {
      if (this.sliderBig.getActiveIndex() !== null && this.sliderMini.getActiveIndex() !== null) {
        let s = this.sliderBig.getActiveIndex();
        if (!s) {
          s = 0;
          console.log('s = 0');
        }

        // this.sliderMini.slideTo(this.activeIndex);
      }
    }
  }

  changeMini(index) {
    if (this.sliderBig.getActiveIndex() !== null && this.sliderMini.getActiveIndex() !== null) {
      this.sliderBig.slideTo(index);
      this.sliderMini.slideTo(index);

    }
  }
  dismiss() {
    this.viewCtrl.dismiss();
  }



}



// WEBPACK FOOTER //
// /src/pages/picture-viewer/picture-viewer.ts